import { useEffect, useState } from "react";
import EyeIcon from "assets/unityMenu/Eye.png";
import EyeCrossedIcon from "assets/unityMenu/EyeCrossed.png";
import classNames from "utilities/ClassNames";
import { useLocationsMenu } from "hooks/useUnityLocations";

const LocationsMenu = () => {
  const { unityLocations, handleSelectLocation, toggleVisibility } = useLocationsMenu();

  const sendStateToUnity = (method: string, readyArguments: any) => {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({
        object: 'ReactUIManager',
        type: 'ReactUIManager',
        method: method,
        arguments: [JSON.stringify(readyArguments)]
      }));
    }
  };

  useEffect(() => {
    sendStateToUnity('SetLocationVisibility', [unityLocations]);
  }, [unityLocations]);

  return (
    <div className="absolute top-11 left-0 right-0 h-max bg-black/95 rounded-md">
      <ul className="w-fullrounded-md">
        {unityLocations.map((location) => {
          return (
            <li key={location.id} className={classNames(location.isSelected ? "bg-dark" : "hover:bg-dark/40", "p-1 flex items-center gap-2 flex-wrap")}>
              <button className="pl-2" onClick={() => toggleVisibility(location.id)}>
                <img className={classNames(location.isVisible ? "h-4" : "h-6", "w-6")} src={location.isVisible ? EyeIcon : EyeCrossedIcon} />
              </button>
              <button className="w-max p-1 flex-grow text-left" onClick={() => handleSelectLocation(location.id)}>
                {location.name}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LocationsMenu;